<template>
    <div
        id="program-filter"
        class="container"
    >
        <div class="program-filter__inner">
            <div class="program-filter__overview-wrapper">
                <div
                    class="program-filter__kicker"
                    v-if="kicker"
                    v-text="kicker"
                />
                <h2
                    class="program-filter__heading"
                    v-text="'Program Finder'"
                />
            </div>
        </div>
        <div
            id="program-filter__inputs-container"
            class="program-filter__controls program-filter__inner"
        >
            <div class="program-filter__search">
                <label for="search-filter" class="program-filter__filter--select-label"><span class="">Search</span></label>
                <div class="program-filter__filter--search-label">
                    <input
                        id="search-filter"
                        v-model="search"
                        class="program-filter__search--input"
                        placeholder="Search"
                        type="search"
                    >
                    <svg
                        class="program-filter__search--icon"
                        viewBox="0 0 13.22 13.19"
                    >
                        <use xlink:href="/o/udliferay-theme/images/symbols/search-icon.svg#search-icon"/>
                    </svg>
                </div>
            </div>
            <div class="program-filter__filter">
                <div class="program-filter__filter--select">
                    <label for="interest-filter" class="program-filter__filter--select-label"><span class="">Filter by Interest</span></label>
                    <div class="program-filter__filter--select-label">
                        <select
                            id="interest-filter"
                            v-model="interest"
                            name="interest"
                            class="program-filter__filter--input"
                        >
                            <option
                                v-for="(inte, index) in interests"
                                :key="index"
                                :value="inte"
                                v-text="inte"
                            />
                        </select>
                        <svg
                            class="arrow__icon"
                            viewBox="0 0 12.09 7.47"
                        >
                            <!-- eslint-disable max-len -->
                            <use xlink:href="/o/udliferay-theme/images/symbols/select-dropdown.svg#select-dropdown"/>
                            <!-- eslint-enable max-len -->
                        </svg>
                    </div>
                </div>
            </div>
             <div class="program-filter__filter">
                <div class="program-filter__filter--select">
                    <label for="degree-filter" class="program-filter__filter--select-label"><span class="">Filter by Outcome</span></label>
                    <div class="program-filter__filter--select-label">
                        <select
                            id="degree-filter"
                            v-model="degree"
                            name="degree"
                            class="program-filter__filter--input"
                        >
                            <option
                                v-for="(deg, index) in degrees"
                                :key="index"
                                :value="deg"
                                v-text="deg"
                            />
                        </select>
                        <svg
                            class="arrow__icon"
                            viewBox="0 0 12.09 7.47"
                        >
                            <!-- eslint-disable max-len -->
                            <use xlink:href="/o/udliferay-theme/images/symbols/select-dropdown.svg#select-dropdown"/>
                            <!-- eslint-enable max-len -->
                        </svg>
                    </div>
                </div>
            </div>
            <div class="program-filter__filter" >
                <div class="program-filter__categories--select">
                    <label for="category-filter" class="program-filter__filter--select-label"><span class="">Filter by Delivery Method</span></label>
                    <div class="program-filter__categories--select-label">
                        <select
                            id="category-filter"
                            v-model="category"
                            name="category"
                            class="program-filter__categories--input"
                        >
                            <option
                                v-for="(cat, index) in categories"
                                :key="index"
                                :value="cat"
                                v-text="cat"
                            />
                        </select>
                        <svg
                            class="arrow__icon"
                            viewBox="0 0 12.09 7.47"
                        >
                            <!-- eslint-disable max-len -->
                            <use xlink:href="/o/udliferay-theme/images/symbols/select-dropdown.svg#select-dropdown"/>
                            <!-- eslint-enable max-len -->
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="program-filter__section">
            <div class="program-filter__group sticky-header" >
                <div>
                    <span class="program-header">Program</span>
                    <span class="container-header">Bachelor's</span>
                    <span class="container-header">Master's</span>
                    <span class="container-header">Bachelor's + Master's</span>
                    <span class="container-header">Doctoral</span>
                    <span class="container-header">Minor</span>
                    <span class="container-header super">License</span>
                    <span class="container-header">Certificate</span>
                    <span class="container-header super">Endorsement</span>
                    <span class="delivery-header">Delivery</span>
                </div>
            </div>
            <transition-group
                        tag="ul"
                        name="fade"
                        class="program-filter__list program-filter__sublist_first"
                    >
                <li
                    v-for="program in programList"
                    :key="
                        'panel_' +
                            program.name.replace(/\s+/g, '-').toLowerCase()
                    "
                    class="program-filter__list-item"
                >
                    <div class="flex-container">
                        <div class="link-container">
                            <a
                                :href="program.links[0].url"
                                class="cta__standard program-link"
                            >
                                <span
                                    class="cta__copy"
                                    v-text="program.name"
                                />
                            </a>
                        </div>
                        <div class="icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Bachelor\'s') !== -1"
                            >
                                <span class="material-icons md-navy">&#9679;</span>
                            </span>
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Bachelor\'s') == -1"
                            >
                                <span class="material-icons md-navy">&#9675;</span>
                            </span>
                        </div>
                        <div class="icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Master\'s') !== -1"
                            >
                                <span class="material-icons md-navy">&#9679;</span>
                            </span>
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Master\'s') == -1"
                            >
                                <span class="material-icons md-navy">&#9675;</span>
                            </span>
                        </div>
                        <div class="icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Bachelor\'s and Master\'s') !== -1"
                            >
                                <span class="material-icons md-navy">&#9679;</span>
                            </span>
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Bachelor\'s and Master\'s') == -1"
                            >
                                <span class="material-icons md-navy">&#9675;</span>
                            </span>
                        </div>
                        <div class="icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Doctoral') !== -1"
                            >
                                <span class="material-icons md-navy">&#9679;</span>
                            </span>
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Doctoral') == -1"
                            >
                                <span class="material-icons md-navy">&#9675;</span>
                            </span>
                        </div>
                        <div class="icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Minor') !== -1"
                            >
                                <span class="material-icons md-navy">&#9679;</span>
                            </span>
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Minor') == -1"
                            >
                                <span class="material-icons md-navy">&#9675;</span>
                            </span>
                        </div>
                        <div class="icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('License') !== -1"
                            >
                                <span class="material-icons md-navy">&#9679;</span>
                            </span>
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('License') == -1"
                            >
                                <span class="material-icons md-navy">&#9675;</span>
                            </span>
                        </div>
                        <div class="icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Certificate') !== -1"
                            >
                                <span class="material-icons md-navy">&#9679;</span>
                            </span>
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Certificate') == -1"
                            >
                                <span class="material-icons md-navy">&#9675;</span>
                            </span>
                        </div>
                        <div class="icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Endorsement') !== -1"
                            >
                                <span class="material-icons md-navy">&#9679;</span>
                            </span>
                            <span class="icon-display-span" 
                            v-if="program.categories.indexOf('Endorsement') == -1"
                            >
                                <span class="material-icons md-navy">&#9675;</span>
                            </span>
                        </div>
                        <div class="delivery-icon-display-div" >
                            <span class="icon-display-span" 
                            v-if="program.delivery.indexOf('Campus') !== -1"
                            >
                                <span class="material-icons md-navy">account_balance</span>
                            </span>

                            <span class="icon-display-span" 
                            v-if="program.delivery.indexOf('Online') !== -1"
                            >
                                <span class="material-icons md-navy">laptop_windows</span>
                            </span>

                        </div>
                    </div>
                </li>
            </transition-group>
            <div class="wysiwyg">
                <br/>
                <p>&#8224; This is an Educator Preparation program (leading to a State of Ohio-issued license).</p>
            </div>
        </div>
    </div> 
</template>

<script>
/* global programFilterSearch (defined in tag manager) */

export default {
    name: 'ProgramFilter',
     props: {
        school: {
            type: String,
            required: false,
            default: ""
        },
        kicker: {
            type: String,
            required: false,
            default: ""
        }
    },
    data() {
        return {
            handle: undefined,
            search: '',
            category: 'All',
            categories: '',
            degree: 'All',
            degrees: '',
            interest: 'All',
            interests: '',
            programs: [],
            programsTop: 0,
            programsBottom: 0,
            scrollTop: 0,
            scrollBottom: 0,
        };
    },
    computed: {
        sticky() {
            return this.programsTop < 70;
            // return this.programsTop < (70 + 62);
        },
        beyondSticky() {
            return this.programsBottom < 100;
            // return this.programsBottom < (70 + 62);
        },

        programList() {
            const programList = [];
            this.programs.forEach((program) => {
              programList.push(program);
            });
            programList.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
            return programList;
        },

        query() {
            return `?search=${this.search}&category=${this.category}&degree=${this.degree}&interest=${this.interest}&school=${this.school}`;
        },
        gaEventSearch() {
            return `${this.search}`;
        },
        gaEventDegree() {
            return `${this.degree}`;
        },
        gaEventInterest() {
            return `${this.interest}`;
        },
        gaEventCategory() {
            return `${this.category}`;
        }
    },
    watch: {
        query() {
            if (this.handle) {
                clearTimeout(this.handle);
            }
            this.handle = setTimeout(this.update, 500);

            if (this.gaHandle) {
                clearTimeout(this.gaHandle);
            }
            this.gaHandle = setTimeout(this.gaEventSearchValue, 3000);
        },
    },
    created() {
        this.fetchDegrees();
        this.fetchCategories();
        this.fetchInterests();

        let uri = window.location.search.substring(1); 
        let parms = new URLSearchParams(uri);
        if(parms.get('degree') !== undefined && parms.get('degree') !== null ) {
            this.degree = parms.get('degree');
        }
        if(parms.get('search') !== undefined && parms.get('search') !== null) {
            this.search = parms.get('search');
        }
        if(parms.get('category') !== undefined && parms.get('category') !== null) {
            this.category = parms.get('category');
        }
        if(parms.get('interest') !== undefined && parms.get('interest') !== null) {
            this.interest = parms.get('interest');
        }


        this.update();
    },
    mounted() {
        const vueThis = this;
        const scrollingElement = document.querySelectorAll('.application')[0];

        this.setBounds();

        scrollingElement.addEventListener('scroll', () => {
            vueThis.setBounds();

            this.scrollTop = scrollingElement.scrollTop;
            this.scrollBottom = scrollingElement.scrollBottom;
        });

        window.addEventListener('resize', () => {
            vueThis.setBounds();
        });
    },
    methods: {
        async update() {
            this.handle = undefined;
            this.programs = await (await fetch(`programs-data.php${this.query}`)).json();
        },
        async fetchDegrees() {
            this.degrees = await (await fetch('/_udayton/php/academics/degrees.php')).json();
        },
        async fetchCategories() {
            this.categories = await (await fetch('/_udayton/php/academics/categories.php')).json();
        },
        async fetchInterests() {
            this.interests = await (await fetch('/_udayton/php/academics/interests.php')).json();
        },
        async gaEventSearchValue() {
            this.gaHandle = undefined;
            programFilterSearch(this.gaEventSearch, this.gaEventDegree, this.gaEventInterest, this.gaEventCategory);
        },
        scrollTo(id) {
            document.querySelectorAll('.application')[0].scrollTop
                += document.getElementById(id).getBoundingClientRect().top
                - (60 + 70 + 62);
        },
        setBounds() {
            const topElement = document.getElementById('program-filter__inputs-container');
            const bottomElement = document.getElementById('program-filter');

            this.programsTop = topElement.getBoundingClientRect().bottom;
            this.programsBottom = bottomElement.getBoundingClientRect().bottom;
        },
    },
};
</script>

<style lang="scss">
$transition-property: opacity, transform;
$transition-duration: 1000ms;
$transition-timing-function: ease;

.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    z-index: 0;
    transition-timing-function: $transition-timing-function;
    transition-duration: $transition-duration;
    transition-property: $transition-property;
}

.fade-leave-active {
    position: absolute;
    z-index: 0;
    transition-timing-function: $transition-timing-function;
    transition-duration: $transition-duration;
    transition-property: $transition-property;
}

.fade-leave-to {
    opacity: 0;
}

.fade-move {
    z-index: 1;
    transition-timing-function: $transition-timing-function;
    transition-duration: $transition-duration;
    transition-property: $transition-property;

    &.v-leave-active {
        transition-timing-function: $transition-timing-function, step-end;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgramFilter.vue